var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowFolderOpenUnselected = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "114px",
    height: "145px",
    viewBox: "0 0 114 145",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Arrow_Folder Copy 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow_Folder-Copy-23",
    fillRule: "nonzero",
    fill: "#1F2631"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7401611,131.590282 L77.7255736,95.0865363 C78.0914755,94.7506063 78.0914755,94.2088464 77.7255736,93.8748582 L37.6018842,57.2507215 C37.3338398,57.0079975 36.929646,56.9322676 36.5786355,57.0643094 C36.227625,57.1963513 36,57.5089798 36,57.8565605 L36,131.108718 L36,131.14367 C36,131.615525 36.4190852,132 36.9381553,132",
    id: "Shape",
    transform: "translate(57.000000, 94.500000) rotate(-270.000000) translate(-57.000000, -94.500000) "
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowFolderOpenUnselected);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_folder_open_unselected.af592bebfb658b2e052694daaebcd005.svg";